import * as React from "react"
import { Flex, Text, INNER_MAX_WIDTH, ColorKeys } from "@capioweb/ui-components/src"
import {
	StringProperty,
	LinkProperty,
} from "../@types/EpiFoundationSpa/Property"

interface BlockCommonLayoutProps {
	id?: string
	heading?: StringProperty
	description?: StringProperty
	link?: LinkProperty
	backgroundColor?: ColorKeys
	noPaddingBottom?: boolean
	children?: React.ReactNode
}

/*
 Wrapper block used for common block alignment

 Max width 1128
 Padding x: { 3 }
 Padding y: { 4 }
*/
export const BlockCommonLayout: React.FC<BlockCommonLayoutProps> = (props) => (
	<Flex
		as="section"
		w={1}
		px={3}
		pt={4}
		pb={props.noPaddingBottom ? 0 : 4}
		id={props.id}
		backgroundColor={props.backgroundColor}
	>
		<Flex
			alignItems="center"
			flexDirection="column"
			w={1}
			maxw={INNER_MAX_WIDTH}
			style={{ margin: "0 auto" }}
		>
			<Flex flexDirection="column" justifyContent="center" maxw={69} m="0 auto">
				{props.heading?.value && (
					<Text as="h2" variant="headline-2" textAlign="center">
						{props.heading.value}
					</Text>
				)}
				{props.description?.value && (
					<Text textAlign="center" mb={3}>
						{props.description.value}
						{props.link && (
							<>
								<br />
								<Text.Link
									to={props.link?.href ?? "#"}
									mb={0}
									underline
									style={{ textDecoration: "underline" }}
								>
									{props.link?.text}
								</Text.Link>
							</>
						)}
					</Text>
				)}
			</Flex>
			{props.children}
		</Flex>
	</Flex>
)

/*
 Wrapper block used for common block alignment that goes full width on small screens

 Max width 1128
 Padding x: { _: 0, m: 3 }
 Padding y: { 4 }
*/
export const BlockFullWidthLayout: React.FC<BlockCommonLayoutProps> = (
	props
) => (
	<Flex as="section" px={{ m: 3 }} py={4} id={props.id}>
		<Flex
			alignItems="center"
			flexDirection="column"
			w={1}
			maxw={INNER_MAX_WIDTH}
			style={{ margin: "0 auto" }}
		>
			<Flex flexDirection="column" justifyContent="center" maxw={69} m="0 auto">
				{props.heading?.value && (
					<Text as="h2" variant="headline-2" textAlign="center">
						{props.heading.value}
					</Text>
				)}
				{props.description?.value && (
					<Text textAlign="center" mb={3}>
						{props.description.value}
						{props.link && (
							<>
								<br />
								<Text.Link to={props.link?.href ?? "#"} mb={0} underline>
									{props.link?.text}
								</Text.Link>
							</>
						)}
					</Text>
				)}
			</Flex>
			{props.children}
		</Flex>
	</Flex>
)

export interface TwoColumnGridLayoutProps {
	items: React.ReactNode[]
}

export const TwoColumnGridLayout: React.FC<TwoColumnGridLayoutProps> = (
	props
) => (
	<Flex
		w={{
			_: 1,
			l: "calc(100% + 24px)",
		}}
		flexDirection={{ _: "column", l: "row" }}
	>
		{props.items.map((item, i) => (
			<Flex
				flex={{ _: 1, m: "0 0 33.33%", l: "0 0 50%" }}
				flexDirection="column"
				px={{ l: 1.5 }}
				key={i}
			>
				{item}
			</Flex>
		))}
	</Flex>
)
